import { useRef, useState, useEffect } from "react";
import { motion, useScroll, useTransform, useInView } from "framer-motion";

const stats = [
  { value: 15, suffix: "+", label: "Years of Experience" },
  { value: 1200, suffix: "+", label: "Events Delivered" },
  { value: 500, suffix: "+", label: "Royal Weddings" },
  { value: 100, suffix: "%", label: "Happy Clients" },
];

function Counter({ value, suffix }) {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true });
  const [n, setN] = useState(0);
  useEffect(() => {
    if (!inView) return;
    let start = 0;
    const dur = 1600;
    const t0 = performance.now();
    const step = (t) => {
      const p = Math.min((t - t0) / dur, 1);
      setN(Math.floor((1 - Math.pow(1 - p, 3)) * value));
      if (p < 1) requestAnimationFrame(step);
    };
    requestAnimationFrame(step);
  }, [inView, value]);
  return <span ref={ref}>{n}{suffix}</span>;
}

export default function Stats() {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["-12%", "12%"]);

  return (
    <section ref={ref} data-testid="stats-section" className="relative py-28 md:py-36 overflow-hidden bg-heirloom-emerald">
      <motion.div style={{ y }} className="absolute inset-0 scale-125">
        <img src="https://images.pexels.com/photos/32315681/pexels-photo-32315681.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1920" alt="" className="w-full h-full object-cover opacity-25" />
      </motion.div>
      <div className="absolute inset-0 bg-heirloom-emerald/70" />
      <div className="relative z-10 max-w-[1300px] mx-auto px-6">
        <div className="text-center mb-14">
          <span className="gold-rule overline text-heirloom-gold-light">Our Journey</span>
          <h2 className="font-display text-4xl md:text-5xl text-heirloom-bone mt-4">Numbers That Speak</h2>
        </div>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
          {stats.map((s, i) => (
            <motion.div key={s.label} initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ delay: i * 0.1 }} className="text-center">
              <div className="font-display text-5xl md:text-6xl font-bold text-heirloom-gold-light"><Counter value={s.value} suffix={s.suffix} /></div>
              <div className="overline text-[0.62rem] text-heirloom-bone/70 mt-3">{s.label}</div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
